import React, {Fragment, useCallback, useState} from 'react';

import {CircularProgress, IconButton, Typography, useTheme} from '@mui/material';
import {GetPrivacyPolicyLinkParams} from 'domain/usecases';
import {makeGetPrivacyPolicyLink} from 'main/factories/usecases';
import {MainFooter, Modal} from 'presentation/components';
import {useGetEndpointUrl, useHostName} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {translations} from 'presentation/translations-new';
import GndiTerms from './components/Terms/GndiTerms';
import HapvidaTerms from './components/Terms/HapvidaTerms';
import {
	StyledCard,
	StyledCardContainer,
	StyledHeader,
	StyledHeaderTitle,
	StyledLink,
} from './styles';
import {TermsOfUseAndPrivacyPolicyProps} from './types';

const {caption, text, textForgotPassword, modalTitle} = translations['pt-br'].publicFlow.termsOfUse;
const {privacyPolicy, and} = translations['pt-br'].commons;

export function TermsOfUseAndPrivacyPolicy({forgotPassword}: TermsOfUseAndPrivacyPolicyProps) {
	const theme = useTheme();
	const {aboveMobile} = useMediaQueries();
	const [isOpenModalTerms, setIsOpenModalTerms] = useState(false);
	const cachedURL = useExternalServiceStore(state => state.urls[privacyPolicy]);
	const termsText = forgotPassword ? textForgotPassword : text;
	const {getLink, isLoading} = useGetEndpointUrl(privacyPolicy);
	const {
		dataHostNameState: {productCode},
		isGndiSaoPaulo,
		isNotredameSaude,
	} = useHostName();

	const readUseTerms = () => {
		setIsOpenModalTerms(!isOpenModalTerms);
	};

	const handleClose = () => {
		setIsOpenModalTerms(!isOpenModalTerms);
	};

	const handleOpenPrivacyPolicy = useCallback(() => {
		if (cachedURL) {
			window.open(cachedURL);
			return;
		}
		const cdEmpresaPlano = productCode?.[0] || 0;
		const params: GetPrivacyPolicyLinkParams = {cdEmpresaPlano, isPpo: isNotredameSaude};
		getLink(makeGetPrivacyPolicyLink, false, false, params);
	}, [cachedURL]);

	return (
		<Fragment>
			<Typography variant="caption">
				{termsText} <StyledLink onClick={readUseTerms}>{caption}</StyledLink> {and}{' '}
				<StyledLink onClick={handleOpenPrivacyPolicy}>{privacyPolicy}</StyledLink>
				{isLoading ? <CircularProgress size={12} sx={{ml: 1}} /> : '.'}
			</Typography>
			<Modal.Root
				open={isOpenModalTerms}
				onClose={handleClose}
				slotProps={{paper: undefined}}
				fullScreen
				fullWidth>
				<StyledHeader>
					<IconButton onClick={handleClose} sx={{pl: aboveMobile ? 0 : 1}}>
						<Icon name="arrow-left-filled" color={theme.palette.common.white} />
					</IconButton>
					<StyledHeaderTitle>{modalTitle}</StyledHeaderTitle>
				</StyledHeader>
				<StyledCardContainer gap={2}>
					<StyledCard>{isGndiSaoPaulo ? <GndiTerms /> : <HapvidaTerms />}</StyledCard>
					<MainFooter noMargin />
				</StyledCardContainer>
			</Modal.Root>
		</Fragment>
	);
}
